document.addEventListener('DOMContentLoaded', () => {
    // Sidebar mobile toggle functionality
    const sidebarMobileBtn = document.querySelector('.sidebar-mobile-btn');
    const profileSection = document.querySelector('.profile-section');
    
    if (sidebarMobileBtn && profileSection) {
        sidebarMobileBtn.addEventListener('click', () => {
            profileSection.classList.toggle('sidebar-active');
        });
    }

    // Remove sidebar-active class when window width > 980px (matching media query)
    function handleResize() {
        if (window.innerWidth > 1024 && profileSection) {
            profileSection.classList.remove('sidebar-active');
        }
    }

    // Add resize event listener
    window.addEventListener('resize', handleResize);
    
    // Check on initial load
    handleResize();

    // Table adaptive functionality
    function initTableAdaptive() {
        const tables = document.querySelectorAll('.table-adaptive');
        
        if (tables.length === 0) return;
        
        tables.forEach(table => {
            const head = table.querySelector('.table-adaptive__head');
            const body = table.querySelector('.table-adaptive__body');
            
            if (!head || !body) return;
            
            const thElements = head.querySelectorAll('.table-adaptive__th > span');
            const trElements = body.querySelectorAll('.table-adaptive__tr');
            
            // Get text content from each th element
            const thTexts = Array.from(thElements).map(th => th.textContent.trim());
            
            // Add data-th attribute to each td in each tr
            trElements.forEach(tr => {
                const tdElements = tr.querySelectorAll('.table-adaptive__td');
                tdElements.forEach((td, index) => {
                    if (thTexts[index]) {
                        td.setAttribute('data-th', thTexts[index]);
                    }
                });
            });
        });
    }
    
    // Initialize table functionality
    initTableAdaptive();

    // Dropdown functionality
    const dropdowns = document.querySelectorAll('.buttons-dropdown');
    if (!dropdowns.length) return;

    dropdowns.forEach(dropdown => {
        const heroButton = dropdown.querySelector('.buttons-dropdown__hero-button');
        const subButtons = dropdown.querySelector('.buttons-dropdown__sub-buttons');

        if (!heroButton || !subButtons) return;

        // Відкриття/закриття по натисканню на heroButton
        heroButton.addEventListener('click', (e) => {
            e.stopPropagation();

            // Спочатку зняти active з усіх інших dropdown'ів
            dropdowns.forEach(d => {
                if (d !== dropdown) d.classList.remove('active');
            });

            // Потім перемкнути поточний
            dropdown.classList.toggle('active');
        });

        // Клік на будь-яку підкнопку — закриває поточний
        subButtons.addEventListener('click', (e) => {
            if (e.target.tagName === 'A') {
                dropdown.classList.remove('active');
            }
        });

        // Клік поза dropdown — закриває всі
        document.addEventListener('click', (e) => {
            if (!dropdown.contains(e.target)) {
                dropdown.classList.remove('active');
            }
      });
  });
});

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-pdf]').forEach(button => {
        button.addEventListener('click', () => {
            const url = button.dataset.pdf;
            printPDF(url);
        });
    });
});

function printPDF(url) {
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.src = url;
    iframe.onload = () => {
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
    };
    document.body.appendChild(iframe);
}
